/*--------------------------------------------------------------
# Custom scripts for Tabbed content block
--------------------------------------------------------------*/

///////////////////////////////////////////////////////////
// START - next previous button for tabbed content

var $ = jQuery.noConflict();

// actions to be taken on click of previous button
$('.tab-control-btn--next').on('click', function(e) {
    e.preventDefault();
    // find active tab link and assign next sibling links href to variable
    var tabContentNextLink = $(this).closest('.tabbed-content__row').find('.tabbed-content-nav__links .active').next('a').attr('href');

    // show next tab - utilising bootstrap JS for tab navs
    $(this).closest('.tabbed-content__row').find('.tabbed-content-nav__links a[href="' + tabContentNextLink + '"]').tab('show');

    // if no more next tabs disable button
    if ( $(this).closest('.tabbed-content__row').find('.tabbed-content-nav__links .active').next('a').length === 0 ) {
        $(this).prop('disabled', true);
        $(this).addClass('disabled');
    }

    // remove disabled state from previous button
    $(this).prev('.tab-control-btn--prev').prop('disabled', false);
    $(this).prev('.tab-control-btn--prev').removeClass('disabled');
});

// actions to be taken on click of previous button
$('.tab-control-btn--prev').on('click', function(e) {
    e.preventDefault();
    // find active tab link and assign previous sibling links href to variable
    var tabContentPrevLink = $(this).closest('.tabbed-content__row').find('.tabbed-content-nav__links .active').prev('a').attr('href');

    // show previous tab - utilising bootstrap JS for tab navs
    $(this).closest('.tabbed-content__row').find('.tabbed-content-nav__links a[href="' + tabContentPrevLink + '"]').tab('show');

    // if no more previous tabs disable button
    if ( $(this).closest('.tabbed-content__row').find('.tabbed-content-nav__links .active').prev('a').length === 0 ) {
        $(this).prop('disabled', true);
        $(this).addClass('disabled');
    }

    // remove disabled state from next button
    $(this).next('.tab-control-btn--next').prop('disabled', false);
    $(this).next('.tab-control-btn--next').removeClass('disabled');
});

// actions to be taken on click of tab nav
$('.tabbed-content-nav__links a').on('click', function() {
    // if on click of tab nav link there is a previous tab remove disabed state from previous button
    if ( $(this).prev('a').length > 0 ) {
        $(this).closest('.tabbed-content__row').find('.tab-control-btn--prev').prop('disabled', false);
        $(this).closest('.tabbed-content__row').find('.tab-control-btn--prev').removeClass('disabled');
    }

    // if on click of tab nav link there is not a previous tab remove disabed state from previous button
    if ( $(this).prev('a').length === 0 ) {
        $(this).closest('.tabbed-content__row').find('.tab-control-btn--prev').prop('disabled', true);
        $(this).closest('.tabbed-content__row').find('.tab-control-btn--prev').addClass('disabled');
    }

    // if on click of tab nav link there is a next tab remove disabed state from next button
    if ( $(this).next('a').length > 0 ) {
        $(this).closest('.tabbed-content__row').find('.tab-control-btn--next').prop('disabled', false);
        $(this).closest('.tabbed-content__row').find('.tab-control-btn--next').removeClass('disabled');
    }

    // if on click of tab nav link there is not a next tab remove disabed state from next button
    if ( $(this).next('a').length === 0 ) {
        $(this).closest('.tabbed-content__row').find('.tab-control-btn--next').prop('disabled', true);
        $(this).closest('.tabbed-content__row').find('.tab-control-btn--next').addClass('disabled');
    }
});

// END - previous next button for tabbed content
/////////////////////////////////////////////////////////